function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
var __defProp = Object.defineProperty;
var __defNormalProp = function(obj, key, value) {
    return key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var __publicField = function(obj, key, value) {
    __defNormalProp(obj, (typeof key === "undefined" ? "undefined" : _type_of(key)) !== "symbol" ? key + "" : key, value);
    return value;
};
// src/signal-events-context-pub-sub-observer/signal-events-context-pub-sub-observer.tsx
var PubSubObserver = /*#__PURE__*/ function() {
    "use strict";
    function PubSubObserver() {
        _class_call_check(this, PubSubObserver);
        __publicField(this, "subscriptions", []);
    }
    _create_class(PubSubObserver, [
        {
            key: "publish",
            value: function publish(signal) {
                this.subscriptions.forEach(function(subscription) {
                    try {
                        if (signal.type === subscription.query.type) {
                            subscription.onSignal(signal);
                        }
                    } catch (e) {
                        var _subscription_onError;
                        (_subscription_onError = subscription.onError) === null || _subscription_onError === void 0 ? void 0 : _subscription_onError.call(subscription, e, signal);
                    }
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(subscription) {
                if (!this.subscriptions.includes(subscription)) {
                    this.subscriptions.push(subscription);
                }
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(subscription) {
                this.subscriptions = this.subscriptions.filter(function(subscribedElement) {
                    return subscription !== subscribedElement;
                });
            }
        }
    ]);
    return PubSubObserver;
}();
var PubSubEventManager = new PubSubObserver();
// src/signal-transition-manager/create-signal-class.ts
import { Signal } from "@shared-ui/core-signal-manager/spi";
function createSignalClass() {
    return /*#__PURE__*/ function(Signal) {
        "use strict";
        _inherits(BaseSignalClass, Signal);
        var _super = _create_super(BaseSignalClass);
        function BaseSignalClass() {
            _class_call_check(this, BaseSignalClass);
            return _super.apply(this, arguments);
        }
        return BaseSignalClass;
    }(Signal);
}
// src/signal-transition-manager/signal-class-factory.ts
var SignalClassFactory = /*#__PURE__*/ function() {
    "use strict";
    function SignalClassFactory() {
        _class_call_check(this, SignalClassFactory);
        __publicField(this, "signalClasses", /* @__PURE__ */ new Map());
    }
    _create_class(SignalClassFactory, [
        {
            key: "getOrCreateSignalClass",
            value: function getOrCreateSignalClass(topic) {
                var upperCaseTopic = topic.toUpperCase();
                if (!this.signalClasses.has(upperCaseTopic)) {
                    this.signalClasses.set(upperCaseTopic, createSignalClass());
                }
                return this.getSignalClass(upperCaseTopic);
            }
        },
        {
            key: "getSignalClass",
            value: function getSignalClass(topic) {
                return this.signalClasses.get(topic.toUpperCase());
            }
        }
    ]);
    return SignalClassFactory;
}();
// src/signal-transition-manager/signal-transition-manager.ts
var SignalTransitionManager = /*#__PURE__*/ function() {
    "use strict";
    function SignalTransitionManager(signalManager) {
        _class_call_check(this, SignalTransitionManager);
        __publicField(this, "signalManager");
        __publicField(this, "signalClassFactory", new SignalClassFactory());
        this.signalManager = signalManager;
    }
    _create_class(SignalTransitionManager, [
        {
            key: "publish",
            value: function publish(eventsContextSignal) {
                var topic = eventsContextSignal.type.toUpperCase();
                if (this.signalManager.getSubscribers(topic)) {
                    var SignalEventClass = this.signalClassFactory.getOrCreateSignalClass(eventsContextSignal.type);
                    if (SignalEventClass) {
                        this.signalManager.publish(new SignalEventClass(topic, eventsContextSignal.payload));
                    }
                }
            }
        },
        {
            key: "subscribe",
            value: function subscribe(subscription) {
                var _this = this;
                var SignalEventClass = this.signalClassFactory.getOrCreateSignalClass(subscription.query.type);
                if (SignalEventClass) {
                    var signalSubscription = {
                        SignalType: SignalEventClass,
                        unsubscribe: /* istanbul ignore next -- @preserve */ function() {
                            return _this.unsubscribe(subscription);
                        }
                    };
                    var callbacks = {
                        onError: function(signal, error) {
                            var _subscription_onError;
                            return (_subscription_onError = subscription.onError) === null || _subscription_onError === void 0 ? void 0 : _subscription_onError.call(subscription, error, {
                                type: signal.topic,
                                payload: signal.payload
                            });
                        },
                        onSuccess: function(signal) {
                            return subscription.onSignal({
                                type: signal.topic,
                                payload: signal.payload
                            });
                        }
                    };
                    this.signalManager.subscribe(subscription.query.type.toUpperCase(), signalSubscription.SignalType, callbacks);
                }
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(subscription) {
                var SignalEventClass = this.signalClassFactory.getSignalClass(subscription.query.type);
                if (SignalEventClass) {
                    var signalSubscription = {
                        SignalType: SignalEventClass,
                        // eslint-disable-next-line @typescript-eslint/no-empty-function
                        unsubscribe: /* istanbul ignore next -- @preserve */ function() {}
                    };
                    this.signalManager.unsubscribe(subscription.query.type.toUpperCase(), signalSubscription);
                }
            }
        }
    ]);
    return SignalTransitionManager;
}();
export { PubSubEventManager, SignalTransitionManager };
//# sourceMappingURL=index.js.map